<script setup lang="ts">
export type BlockSectionFeatureItem = {
    title: string;
};

// PROPS
defineProps({
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    items: { type: Array as PropType<BlockSectionFeatureItem[]>, default: () => [] },
});
</script>

<template>
    <div class="flex flex-col gap-8 md:grid md:grid-cols-2">
        <BlockItem v-for="(item, index) in items" :key="index" v-bind="item" :index="index + 1" />
    </div>
</template>
